import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { File, IWriteOptions } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    constructor(public platform: Platform, private file: File, private fileOpener: FileOpener) { }
    directory = this.file.dataDirectory;

    // IMPORTANT, MAKE SURE THE COLUMN PROPERTIES COME IN AS TITLE THEN HEADER, NOT HEADER THEN TITLE 
    //{title: 'Date', dataKey: 'TransactionDate'}
    exportData(data: any, fileNameOnly: any, exportColumns: any) {
        try {
            let fileName = fileNameOnly + ".pdf";
            let doc = new jsPDF('l', 'pt') as any;
            doc.autoTable(exportColumns, data);
            var pdfOutput = doc.output();

            let buffer = new ArrayBuffer(pdfOutput.length);
            let array = new Uint8Array(buffer);
            for (var i = 0; i < pdfOutput.length; i++) {
                array[i] = pdfOutput.charCodeAt(i);
            }

            let options: IWriteOptions = {
                replace: true,
            };
            this.file
                .checkFile(this.directory, fileName)
                .then((res) => {
                    this.file
                        .writeFile(this.directory, fileName, buffer, options)
                        .then((res) => {
                            this.fileOpener
                                .open(this.directory + fileName, 'application/pdf')
                                .then(() => console.log('File is exported'))
                                .catch((e) => console.error(e));
                        })
                        .catch((error) => {
                            console.error(JSON.stringify(error));
                        });
                })
                .catch((error) => {
                    this.file
                        .writeFile(this.directory, fileName, buffer)
                        .then((res) => {
                            this.fileOpener
                                .open(this.directory + fileName, 'application/pdf')
                                .then(() => console.log('File exported'))
                                .catch((e) => console.error(e));
                        })
                        .catch((error) => {
                            console.error(JSON.stringify(error));
                        });
                });
        } catch (error) {
            console.error('Unable to write file', error);
        }
    }

    exportHTMLToPDF(html: string, fileName: string) {
        try {
            var doc = new jsPDF("p", "pt", "a4");
            doc.html(html, {
                margin: 2,
                filename: fileName, callback: (d) => {
                    var pdfOutput = d.output();
                    let buffer = new ArrayBuffer(pdfOutput.length);
                    let array = new Uint8Array(buffer);
                    for (var i = 0; i < pdfOutput.length; i++) {
                        array[i] = pdfOutput.charCodeAt(i);
                    }

                    if (this.platform.is('mobileweb')) {
                        var string = doc.output('datauristring');
                        var embed = "<embed width='100%' height='100%' src='" + string + "'/>"
                        var x = window.open();
                        x.document.open();
                        x.document.write(embed);
                        x.document.close();
                    }
                    else {
                        this.saveFile(fileName, buffer, 'application/pdf');
                    }
                },
                x: 15,
                y: 15,
                width: this.platform.width() / 2,
                windowWidth: this.platform.width() / 2,
                autoPaging: true
            });
        } catch (error) {

        }
    }

    exportClassInCsv(data: string, serviceName: string) {
        let buffer = new ArrayBuffer(data.length);
        let array = new Uint8Array(buffer);
        for (var i = 0; i < data.length; i++) {
            array[i] = data.charCodeAt(i);
        }

        let fileName = `${serviceName}.csv`;
        this.saveFile(fileName, buffer, 'text/csv');
    }

    exportContactCards(vCard: string, profileName: string) {
        let buffer = new ArrayBuffer(vCard.length);
        let array = new Uint8Array(buffer);
        for (var i = 0; i < vCard.length; i++) {
            array[i] = vCard.charCodeAt(i);
        }

        let fileName = `${profileName}.vcf`;
        this.saveFile(fileName, buffer, 'text/x-vcard');
    }

    private saveFile(fileName, buffer, fileType) {
        let options: IWriteOptions = {
            replace: true,
        };

        this.file
            .checkFile(this.directory, fileName)
            .then((res) => {
                this.file
                    .writeFile(this.directory, fileName, buffer, options)
                    .then((res) => {
                        this.fileOpener
                            .open(this.directory + fileName, fileType)
                            .then(() => console.log('File is exported'))
                            .catch((e) => console.error(e));
                    })
                    .catch((error) => {
                        this.file
                            .writeFile(this.directory, fileName, buffer, options)
                            .then((res) => {
                                this.fileOpener
                                    .open(this.directory + fileName, fileType)
                                    .then(() => console.log('File is exported'))
                                    .catch((e) => console.error(e));
                            });
                    });
            })
            .catch((error) => {
                this.file
                    .writeFile(this.directory, fileName, buffer, options)
                    .then((res) => {
                        this.fileOpener
                            .open(this.directory + fileName, fileType)
                            .then(() => console.log('File is exported'))
                            .catch((e) => console.error(e));
                    });
            });
    }
}